import axios from 'axios';
import { redirectToLogin } from '../api/auth/actions';
import { ErrorHandler } from './error_handler';
import { AUTH_ERROR_CODES, ERROR_CODES } from '../api/error_codes';

// Configure axios defaults
axios.defaults.withCredentials = true;

// Add response interceptor to handle structured error responses
axios.interceptors.response.use(
    (response) => {
        //console.log('Axios response:', response);
        // Check if response contains an error code (all responses now return 200 OK)
        if (response.data?.Code && response.data.Code !== '200') {
            // Check if it's an authentication error
            if (ErrorHandler.isAuthError(response.data.Code)) {
                // Redirect to CPASS login for auth errors
                //redirectToLogin();
                console.log(response.data, "Auth error, need to re-login")
                
                // Create error with code for handling
                const error = new Error(response.data.Msg);
                (error as any).code = response.data.Code;
                (error as any).response = response;
                return Promise.reject(error);
            }
        }
        
        // Return successful response
        return response;
    },
    (error) => {
        //console.error('Axios error:', error);
        // Handle network errors (no response from server)
        if (!error.response) {
            const errorCode = ErrorHandler.handleAxiosError(error);
            const enhancedError = new Error(ErrorHandler.getUserMessage(errorCode, 'Network error occurred'));
            (enhancedError as any).code = errorCode;
            (enhancedError as any).originalError = error;
            return Promise.reject(enhancedError);
        }
        
        // Return the error for further handling
        return Promise.reject(error);
    }
);

// Export configured axios instance
export default axios;